/**
 * Created by fers on 26.09.15.
 */

import { declareEntity } from '../fw/MetaDataHelper.ts';
import { v4 as uuidv4 } from 'uuid';

export default declareEntity({
    entity: "fetchStats",
    graphQL: "FetchStat",
    name: "Fetch Statistics",
    dynamoPrefix: 'org',
    storageType: 'central',
    fields: (types) => { return {
        id: {
            name: "ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: false,
        },
        instance: {
            name: "Instance",
            type: "relation",
            to: () => types['instances'],
            userEditable: false,
        },
        organisation: {
            name: "Organisation",
            type: "relation",
            to: () => types['organisations'],
            defaultValue: (channel) => {
                return channel['organisation_id'];
            },
            required: true
        },
        channel: {
            name: "Application",
            type: "relation",
            to: () => types['channels'],
            required: true
        },
        channelDef: {
            name: "Application Definition",
            type: "relation",
            to: () => types['channelDefs'],
            required: true
        },
        flow: {
            name: "Flow",
            type: "relation",
            to: () => types['flows'],
        },
        flowDef: {
            name: "Flow Definition",
            type: "relation",
            to: () => types['flowDefs'],
        },
        period: {
            name: "Period",
            type: "string",
        },
        periodStart: {
            name: "Period Start",
            type: "datetime",
        },
        periodEnd: {
            name: "Period End",
            type: "datetime",
        },
        fetchCount: {
            name: "Fetch Count",
            type: "int",
        },
        dataLength: {
            name: "Data Length",
            type: "bigint",
        },
        price: {
            name: "Price",
            type: "number",
            userEditable: false,
            import: false,
            export: false,
            rereadDataForControllerFn: false,
            controllerFn: "getPrice",
        },
        endPrice: {
            name: "Price",
            type: "number",
            userEditable: false,
            import: false,
            export: false,
            rereadDataForControllerFn: false,
            controllerFn: "getEndPrice",
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            filterable: true,
            userEditable: false,
        },

    }; },
    relations: (types) => { return {
    }; }
});
